import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subscription, map } from 'rxjs';

import { IBetslipRootState } from '../../../base/store/state';
import { BetslipOverAskActions } from '../actions';
import { overAskStateSelector } from '../selectors';
import { OverAskMessagesProvider } from '../services/over-ask-messages.provider';

@Component({
    template: '',
    standalone: false,
})
export class BetslipOverAskPlaceBetButtonBaseComponent implements OnDestroy {
    texts: {
        totalOdds: string;
        maxReturn: string;
        acceptChangesAndPlaceBet: string;
        acceptChanges: string;
    };

    props: {
        hasOfferChanges: boolean;
    };

    disabled = false;
    subscription: Subscription | undefined;

    constructor(
        private store: Store<IBetslipRootState>,
        private changeDetertor: ChangeDetectorRef,
        overAskMessagesProvider: OverAskMessagesProvider,
    ) {
        this.texts = {
            totalOdds: overAskMessagesProvider.messages.totalOdds,
            maxReturn: overAskMessagesProvider.messages.maxReturn,
            acceptChangesAndPlaceBet: overAskMessagesProvider.messages.acceptChangesAndPlaceBet,
            acceptChanges: overAskMessagesProvider.messages.acceptChanges,
        };

        this.subscription = this.store
            .select(overAskStateSelector)
            .pipe(map((state) => state.bets.every((bet) => bet.isRemoved)))
            .subscribe((isAllRemoved) => {
                this.disabled = isAllRemoved;
                this.changeDetertor.markForCheck();
            });
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    onClick(): void {
        if (this.props.hasOfferChanges) {
            this.store.dispatch(BetslipOverAskActions.acceptBettingOfferChanges());
        } else {
            this.store.dispatch(BetslipOverAskActions.acceptOffer());
        }
    }
}
